import { AxiosError } from 'axios';
import { logger } from '@fiverr-private/obs';

/**
 * Log an error only if it's not an AxiosError. To avoid double logging.
 */
export const logNonAxiosError = (error: Error, description: string, enrichment?: object) => {
    if (error instanceof AxiosError) {
        return;
    }

    logger.error(error, { description, ...enrichment });
};
